<template>
 <!-- v-if="pageId==='13'" -->
  <!-- :style="!isPhone? 'width:1250px;':'width:99%'  " -->
 <div  class="function_wrap"  >
     <!-- class="function_wrap" id='function_wrap'  -->
            <consult v-if="!isPhone"></consult>
            <div  :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' " id='function_box0'  :style="'background-color: #fff;min-height:'+(screenHeight-80)+'px;'" >
                <!-- <div class="function_wrap_title">基准利息计算器</div> -->
                <h1 class="function_wrap_title">旧基准利息计算器 </h1>
                <div class="function_wrap_title_EN">（19年8月20日以前）</div>
                  <div style="width:100%;margin-top:15px">
                        <div style="float:right"> 
                            <a    href="/lpr"  target='_blank'  class="guide" style="margin-right:20px;text-decoration:none">   
                                19年8月20日以后的基准利率计算，请使用lpr利率计算器
                                <i class="el-icon-d-arrow-right"></i> 
                            </a>       
                              

                        </div>
                        <!--  
                   
                    <a  style="margin-left:40px;text-decoration: underline; color: rgb(19, 109, 145);"  href="/lpr"  target='_blank'  class="guide">   
                        查看详情word模板
                    </a>      -->

              

                </div> 
        
  
                <!-- <el-form ref="form" :model="param" label-width="180px" style="margin-top:40px;width:90%;max-width:800px"  class="form_wrap" >
                    <el-form-item label="金额">
                        <el-input v-model="inputValue"></el-input>
                    </el-form-item>

                    <el-form-item label="起止日期">
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="date[0]" style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2" style="text-align:center"> 至 </el-col>
                        <el-col :span="11">
            
                            <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="date[1]" style="width: 100%;"></el-date-picker>
                       
                        </el-col>
                    </el-form-item>

                    <el-form-item label="自然年天数基准：" style="text-align:center">
                        <el-radio-group v-model="day_base"  >
                            <el-radio :label="360">360</el-radio>
                            <el-radio :label="365">365</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="天数算法：" style="text-align:center">
                        <el-radio v-model="days_mode"  :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " label="mode_d1" border>算头不算尾</el-radio>
                        <el-radio v-model="days_mode"  :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " label="mode_d2" border>两头都算</el-radio>
                        
                    </el-form-item>


  


                </el-form> -->

               
               
                <div class='optionitem'  :style="isPhone?'width:100%':'' ">   
                    <div class="optionitem item_name" >输入金额：</div>
                    <div class="optionitem item_detail"> <el-input style="max-width:700px" type='number' min=0 v-model="inputValue" placeholder="请输入金额"></el-input> </div> 
                </div>  

                <div class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name" >起止日期：</div>
                   
                    <!-- <div  class="optionitem item_detail"  >

                        <el-date-picker
                            value-format="yyyy-MM-dd"
                            v-model="date"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style=" width:100% ">
                        </el-date-picker>
                    </div> -->

                    <div  class="optionitem item_detail" style="margin-left:0; flex-wrap:nowrap; "   >
                   
                        <el-date-picker
                            @change="DateChangeHandle"
                            style="width:332px"
                            v-model="date[0]"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            
                            >
                        </el-date-picker>

                        <span  :style="isPhone?'margin: 10px 10px ':'margin: 0 10px 0 10px' "  >至</span>
             

                        <el-date-picker
                            @change="DateChangeHandle"
                            style="width:332px"
                            v-model="date[1]"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            >
                            
                        </el-date-picker>


 


                    </div>
    
                </div>  

                <!-- <div class='optionitem' :style="isPhone?'width:100%':'' ">   
                
                    <div  class="optionitem item_detail guide" style=" min-height: 0" >
                       1231
                    </div>
    
                </div>  -->



               

                <div class='optionitem' :style="isPhone?'width:100%':'' " >   
                    <div class="optionitem item_name">自然年天数基准：</div>
                    <div class="optionitem item_detail"  > 
                   
                        <!-- <el-radio-group v-model="day_base"  >
                            <el-radio :label="360">360</el-radio>
                            <el-radio :label="365">365</el-radio>
                        </el-radio-group> -->

                        <el-radio v-model="day_base"  :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " :label="360" border>360</el-radio>
                        <el-radio v-model="day_base"  :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " :label="365" border>365</el-radio>
                        

                    </div>

                </div> 

             

                


                <!-- <div class='optionitem' :style="isPhone?'width:100%':'' ">   
                    <div class="optionitem item_name">倍数：</div>
                    <div class="optionitem item_detail"> 
           
                        <el-radio v-model="ishalf" label="1" border>一倍</el-radio>
                        <el-radio v-model="ishalf" label="2" border>二倍</el-radio>
         
                    
                    </div>

                </div>   -->


                <div class='optionitem' :style="isPhone?'width:100%':'' ">   
                    <div class="optionitem item_name">天数算法：</div>
                    <div class="optionitem item_detail"> 
                        <!-- <p v-on:click="bindhalf1" :style="half_bg1" >是</p>
                        <p v-on:click="bindhalf2" :style="half_bg2" >否</p> -->
                        <!-- <el-radio v-model="ishalf" label="1">备选项</el-radio>
                        <el-radio v-model="ishalf" label="2">备选项</el-radio> -->
                        <el-radio v-model="days_mode"  :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " label="mode_d1" border>算头不算尾</el-radio>
                        <el-radio v-model="days_mode"  :style="!isPhone?'':'margin:auto'" :size="isPhone? 'mini':'' " label="mode_d2" border>两头都算</el-radio>
                        
                        <!-- <template>
                            <el-radio v-model="radio" label="1">备选项</el-radio>
                            <el-radio v-model="radio" label="2">备选项</el-radio>
                        </template> -->
                        <el-tooltip class="item" effect="dark" content="标准是算头不算尾，用户可根据实务需要自行选择" placement="top-start">
                            <i class="el-icon-question"  ></i>
                        </el-tooltip>
                    </div>

                </div> 
                <!-- <div class='optionitem' style="font-size:14px;text-align:left;margin-top:10px">(银行利息计算方式下，一般算头不算尾，是之前的默认方式。根据部分客户的需求，增加算头又算尾的方式。标准算法是需要分段计算利息，年天数以360计。但根据部分客户的要求，增加了选项，您可以根据实际需求选择)</div> -->

                <div class='optionitem' :style="isPhone?'width:100%':'' ">   
                    <div class="optionitem item_name">利率档次：</div>
                    <div  class="optionitem item_detail" >
                        {{level}}
                        <!-- <el-select v-model="level" placeholder="请选择"   value-key="label"> 
                            <el-option
                            v-for="item in level_range"
                            :key="item.value"
                            :label="item.label"
                            :value="item">
                            </el-option>
                        </el-select>
                        （系统会自动选择，也可以主动选择）
                      
                        <el-tooltip class="item" effect="dark" placement="top-start">
                            <div slot="content">旧版利率档次根据日期跨度选择，基于部分地区实践和一些用户需求，<br/>用户可以自行选择利率档</div>
                            <i class="el-icon-question"></i>   
                        </el-tooltip> -->

                    </div>
    
                </div> 


                <div class='optionitem' :style="isPhone?'width:100%':'' ">   
                    <div class="optionitem item_name">计算模型：</div>
                    <div class="optionitem item_detail"> 
                     <el-radio-group v-model="mode">
                        <el-radio  label="1" border>分段</el-radio>
                        <el-radio  label="2" border>不分段</el-radio>
         
                      </el-radio-group>
                        
                        <el-tooltip class="item" effect="dark" content="过去实务以分段为主，基于部分地区实践和一些用户需求，用户可以选择不分段模式" placement="top-start">
                            <i class="el-icon-question" style="margin-left:20px"></i>
                        </el-tooltip>
                    </div>
                    

                </div>  


      

              


                <div  style="margin-top:60px">
                    <!-- <button @click="alert('ok')" type="button">Click Me!</button>
                    <button type="button">Cancle!</button> -->
                    <el-row>

                        <el-button @click="bindcalculate" type="primary">确定</el-button>
                        <el-button @click="resetEvent" type="warning" style="margin-left: 50px;">清空</el-button>
                
                    </el-row>
                </div>

       
               
                      


                <div class="result">
                    <h4>计算结果：</h4>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;天数共计： {{gap}} 日</p>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;利息共计：{{result1}}元</p>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;本息共计：{{result2}}元</p>
                    <p v-if="mode=='2'" v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;计算公式：{{algorithm}} </p>
                     
                    <p  style="font-weight:600;margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;备注：结果仅供参考，数据来源：中国人民银行贷款基准利率。</p>
                    <div  style="font-weight:600;margin-top:5px;word-wrap: break-word;">&nbsp;&nbsp;&nbsp;&nbsp;查看全部利率： <a href='/community/55u49525809719' target="_blank">https://www.lawtip.cn/community/55u49525809719</a>  </div>
                    
                    <div style="width:100%">
                        <el-button type="primary" style="float:right" plain @click="bind_download">下载详情文档(VIP专享)</el-button>
                    </div>
                    
                    <!-- <p>{{inputValue}}</p> -->
                </div>

             
                  <!-- v-if='method=="1"' -->
                <el-table
                  
                    :data="tableData"
                    stripe
                    style="width: 90%">
                    <el-table-column
                    prop="name"
                    label="明细（1倍）"
                     >
                    </el-table-column>
                    <el-table-column
                    prop="ratio"
                    label="利率"
                     >
                    </el-table-column>
                    <el-table-column
                    prop="days"
                    label="天数">
                    </el-table-column>
                    <el-table-column
                    prop="amount"
                    label="利息金额">
                    </el-table-column>
                </el-table>

                <!-- <el-table
                    v-if='method=="2"'
                    :data="tableData"
                    stripe
                    style="width: 90%">
                    <el-table-column
                    prop="level"
                    label="明细（1倍）"
                     >
                    </el-table-column>
                    <el-table-column
                    prop="current_int"
                    label="利率"
                     >
                    </el-table-column>
                    <el-table-column
                    prop="day_sum"
                    label="天数">
                    </el-table-column>
                    <el-table-column
                    prop="lixi"
                    label="利息金额">
                    </el-table-column>
                </el-table> -->
           
            </div>   
        </div>

</template>

<script>

import { IncUseNumber } from '@/assets/js/cal/cal.js'; 

// function DateDiff(sDate1, sDate2) {    //sDate1和sDate2是2002-12-18格式  
//     var aDate, oDate1, oDate2, iDays
//     aDate = sDate1.split("-")
//     oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])    //转换为12-18-2002格式  
//     aDate = sDate2.split("-")
//     oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
//     iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24)    
//     //把相差的毫秒数转换为天数  
//     console.log('iDays:',iDays)
//     return iDays
// }

function DateDiff(sDate1, sDate2) {    //sDate1和sDate2是2002-12-18格式  
    var aDate, oDate1, oDate2, iDays
    aDate = sDate1.split("-")
    oDate1 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])    //转换为12-18-2002格式  
    aDate = sDate2.split("-")
    oDate2 = new Date(aDate[1] + '/' + aDate[2] + '/' + aDate[0])
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24)    
    //把相差的毫秒数转换为天数  
    console.log('iDays:',iDays)
    return iDays
}

var filters = {
    toFix: function (value) {
        return value.toFixed(2)//此处2为保留两位小数
    }
} 

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}


function guid2() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4()  + S4()  + S4() +  S4() +  S4() + S4() + S4());
}



 import consult from '@/components/ads/consult.vue' 

	export default {
        name: 'interest',
        metaInfo: {
            title: '基准利息计算器|司法利率计算器', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '基准利息计算,律师工具,找律师,lpr司法计算'
            }],
      
        },
		props: {
            // isPhone: Boolean
        },
        components: { 
            consult
        },
        data() {
			return { 
                cond:'1', //1 纯旧计算,2 新旧结合 ,3 纯lpr计算
                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                isPhone:false,
                days_mode:'mode_d1',
                level_range:[
                    {label:'一年以内',value:'year1' },
                    {label:'一至五年（含五年）',value:'year5' },
                    {label:'五年以上',value:'year5_up' },
                
                ],
                
                inputValue:'',
                date:['',''],
                result1:0,
                result2:0,
                ishalf:'1',
                level :'',
                day_base:360,
                algorithm:'',

                on_off:'none',
                lixi:0,
                rate1:0,
                rate2:0,
                rate3:0,
                rate4:0,
                rate5:0,
                day1:0,
                day2:0,
                day3:0,
                day4:0,
                day5:0,
                day_sum:0,
                amount1:0,
                amount2:0,
                amount3:0,
                amount4:0,
                amount5:0,
                amount_sum:0,
                tableData:[],
                mode:'1',
                gap:'',
                // tableData:  [{
                //         name: '六个月内',
                //         ratio:'',
                //         days:'',
                //         amount:'',
                //         }, {
                //         name: '六个月至一年',
                //         ratio:'',
                //         days:'',
                //         amount:'',
                //         }, {
                //         name: '一年至三年',
                //         ratio:'',
                //         days:'',
                //         amount:'',
                //         }, {
                //         name: '三年至五年',
                //         ratio:'',
                //         days:'',
                //         amount:'',
                //         }, {
                //         name: '五年以上',
                //         ratio:'',
                //         days:'',
                //         amount:'',
                //         }, {
                //         name: '合计',
                //         ratio:'/',
                //         days:'',
                //         amount:'',
                //         }]
                
            }
        },

        mounted() {
            IncUseNumber('interest')
            this.isPhone=isphone()

        },
          methods:{


   
        resetEvent(){
            this.inputValue='';
            this.result1='';
            this.result2='';
            this.tableData=[];
        },
        DateChangeHandle(){
            window.console.log('date=',this.date);
            if(this.date[0] && this.date[1]){
                var s1 = this.date[0];
                var s2 = this.date[1];
                var date_s1=new Date(s1)
                var date_s2=new Date(s2)
                if(date_s1>date_s2){
                    // alert('截止日期请大于开始日期哦');
                    this.$message({
                        message: '截止日期请大于开始日期哦',
                        type: 'warning',
                        duration:4000,
                        showClose:true,

                    });
                    return false;

                }
                let divide=new Date('2019-08-20')
                if(date_s2<=divide ){
                    this.cond='1'
                }else if(date_s1<divide && date_s2>divide  ){
                    this.cond='2'
                }else{
                    this.cond='3'
                }


                 
                
            }

        },

        bindcalculate: function () {   
            window.console.log('date=',this.date);
            // var that = this;
            var t = this.inputValue;
            if(!this.date[0] || !this.date[1]){
                alert('日期记得选择哦');
                return false;
            }
            
            var s1 = this.date[0];
            var s2 = this.date[1];
            var date_s1=new Date(s1)
            var date_s2=new Date(s2)

            if(date_s1>date_s2){
                alert('截止日期请大于开始日期哦');
                return false;

            }

            window.console.log('date_s2=',date_s2);
       
            var gap = DateDiff(s1, s2);
    
            if(this.days_mode=='mode_d2'){
                gap++
            }

            // var gap=(s2-s1)/86400000;
            window.console.log('gap:',gap,'s1:',s1,'s2:',s2)
            this.gap=gap 
 
            var a0,a1,a2,a3,a4 // time; 
            var interest //sum;

   
        
            if(date_s2>=new Date('2015-10-24') )
            {
                a0=0.0435;
                a1=0.0435;
                a2=0.0475;
                a3=0.0475;
                a4=0.049;
            }
            else if (date_s2 >= new Date('2015-8-26') && date_s2< new Date('2015-10-24')  )
            {
                a0 = 0.046;
                a1 = 0.046;
                a2 = 0.05;
                a3 = 0.05;
                a4 = 0.0515;

            }
            else if (date_s2 >= new Date('2015-6-28') && date_s2 < new Date('2015-8-26') ) {
                a0 = 0.0485;
                a1 = 0.0485;
                a2 = 0.0525;
                a3 = 0.0525;
                a4 = 0.054;

            }
            else if (date_s2 >= new Date('2015-5-11') && date_s2 < new Date('2015-6-28') ) {
                a0 = 0.051;
                a1 = 0.051;
                a2 = 0.055;
                a3 = 0.055;
                a4 = 0.0565;

            }
            else if (date_s2 >= new Date('2015-3-1') && date_s2 < new Date('2015-5-11')  ) {
                a0 = 0.0535;
                a1 = 0.0535;
                a2 = 0.0575;
                a3 = 0.0575;
                a4 = 0.059;

            }
            else if (date_s2 >= new Date('2014-11-22') && date_s2 < new Date('2015-3-1') ) {
                a0 = 0.056;
                a1 = 0.056;
                a2 = 0.06;
                a3 = 0.06;
                a4 = 0.0615;

            }
            else if (date_s2 >= new Date('2012-7-6') && date_s2 < new Date('2014-11-22') ) {
                a0 = 0.056;
                a1 = 0.06;
                a2 = 0.0615;
                a3 = 0.064;
                a4 = 0.0655;

            }
            else if (date_s2 >= new Date('2012-6-8') && date_s2 < new Date('2012-7-6')  ) {
                a0 = 0.0585;
                a1 = 0.0631;
                a2 = 0.064;
                a3 = 0.0665;
                a4 = 0.068;

            }
            else if (date_s2 >= new Date('2011-7-7') && date_s2 < new Date('2012-6-8') ) {
                a0 = 0.061;
                a1 = 0.0656;
                a2 = 0.0665;
                a3 = 0.069;
                a4 = 0.0705;

            }
            else if (date_s2 >= new Date('2011-4-6') && date_s2 < new Date('2011-7-7')  ) {
                a0 = 0.0585;
                a1 = 0.0631;
                a2 = 0.064;
                a3 = 0.0665;
                a4 = 0.068;

            }
            else if (date_s2 >= new Date('2011-2-9') && date_s2 < new Date('2011-4-6') ) {
                a0 = 0.056;
                a1 = 0.0606;
                a2 = 0.061;
                a3 = 0.0645;
                a4 = 0.066;

            }
            else if (date_s2 >= new Date('2010-12-26') && date_s2 < new Date('2011-2-9') ) {
                a0 = 0.0535;
                a1 = 0.0581;
                a2 = 0.0585;
                a3 = 0.0622;
                a4 = 0.064;

            }
            else if (date_s2 >= new Date('2010-10-20') && date_s2 < new Date('2010-12-26')  ) {
                a0 = 0.051;
                a1 = 0.0556;
                a2 = 0.056;
                a3 = 0.0596;
                a4 = 0.0614;

            }
            else if (date_s2 >= new Date('2008-12-23') && date_s2 < new Date('2010-10-20') ) {
                a0 = 0.0486;
                a1 = 0.0531;
                a2 = 0.054;
                a3 = 0.0576;
                a4 = 0.0594;

            }
            else if (date_s2 >= new Date('2008-11-27') && date_s2 < new Date('2008-12-23') ) {
                a0 = 0.0504;
                a1 = 0.0558;
                a2 = 0.0567;
                a3 = 0.0594;
                a4 = 0.0612;

            }else if (date_s2 >=new  Date('2008-10-30') && date_s2 <new  Date('2008-11-27')) {
                a0 = 0.0603;
                a1 = 0.0666;
                a2 = 0.0675;
                a3 = 0.0702;
                a4 = 0.0720;

                }    else if (date_s2 >=new  Date('2008-10-09') && date_s2 <new  Date('2008-10-30')) {
                a0 = 0.0612;
                a1 = 0.0693;
                a2 = 0.0702;
                a3 = 0.0729;
                a4 = 0.0747;

                } else if (date_s2 >=new  Date('2008-09-16') && date_s2 <new  Date('2008-10-09')) {
                a0 = 0.0621;
                a1 = 0.0720;
                a2 = 0.0729;
                a3 = 0.0756;
                a4 = 0.0774;

                }else if (date_s2 >=new  Date('2007-12-21') && date_s2 <new  Date('2008-09-16')) {
                a0 = 0.0657;
                a1 = 0.0747;
                a2 = 0.0756;
                a3 = 0.0774;
                a4 = 0.0783;

                }else if (date_s2 >=new  Date('2007-09-15') && date_s2 <new  Date('2007-12-21')) {
                a0 = 0.0648;
                a1 = 0.0729;
                a2 = 0.0747;
                a3 = 0.0765;
                a4 = 0.0783;

                }else if (date_s2 >=new  Date('2007-08-22') && date_s2 <new  Date('2007-09-15')) {
                a0 = 0.0621;
                a1 = 0.0702;
                a2 = 0.0720;
                a3 = 0.0738;
                a4 = 0.0756;
            
                }else if (date_s2 >=new  Date('2007-07-21') && date_s2 <new  Date('2007-08-22')) {
                a0 = 0.0603;
                a1 = 0.0684;
                a2 = 0.0702;
                a3 = 0.0720;
                a4 = 0.0738;
            
                }else if (date_s2 >=new  Date('2007-05-19') && date_s2 <new  Date('2007-07-21')) {
                a0 = 0.0585;
                a1 = 0.0657;
                a2 = 0.0675;
                a3 = 0.0693;
                a4 = 0.0720;
            
                }else if (date_s2 >=new  Date('2007-03-18') && date_s2 <new  Date('2007-05-19')) {
                a0 = 0.0567;
                a1 = 0.0639;
                a2 = 0.0657;
                a3 = 0.0675;
                a4 = 0.0711;

                }else if (date_s2 >=new  Date('2006-08-19') && date_s2 <new  Date('2007-03-18')) {
                a0 = 0.0558;
                a1 = 0.0612;
                a2 = 0.0630;
                a3 = 0.0648;
                a4 = 0.0684;

                }else if (date_s2 >=new  Date('2006-04-28') && date_s2 <new  Date('2006-08-19')) {
                a0 = 0.0540;
                a1 = 0.0585;
                a2 = 0.0603;
                a3 = 0.0612;
                a4 = 0.0639;
                }else if (date_s2 >=new  Date('2004-10-29') && date_s2 <new  Date('2006-04-28')) {
                a0 = 0.0522;
                a1 = 0.0558;
                a2 = 0.0576;
                a3 = 0.0585;
                a4 = 0.0612;
                }else if (date_s2 >=new  Date('2002-02-21') && date_s2 <new  Date('2004-10-29')) {
                a0 = 0.0504;
                a1 = 0.0531;
                a2 = 0.0549;
                a3 = 0.0558;
                a4 = 0.0576;
                }else if (date_s2 >=new  Date('1999-06-10') && date_s2 <new  Date('2002-02-21')) {
                a0 = 0.0558;
                a1 = 0.0585;
                a2 = 0.0594;
                a3 = 0.0603;
                a4 = 0.0621;
            } else if (date_s2 >=new  Date('1998-12-07') && date_s2 <new  Date('1999-06-10')) {
                a0 = 0.0612;
                a1 = 0.0639;
                a2 = 0.0666;
                a3 = 0.0720;
                a4 = 0.0756;
                }else if (date_s2 >=new  Date('1998-07-01') && date_s2 <new  Date('1998-12-07')) {
                a0 = 0.0657;
                a1 = 0.0693;
                a2 = 0.0711;
                a3 = 0.0765;
                a4 = 0.0801;
                }else if (date_s2 >=new  Date('1998-03-25') && date_s2 <new  Date('1998-07-01')) {
                a0 = 0.0702;
                a1 = 0.0792;
                a2 = 0.0900;
                a3 = 0.0972;
                a4 = 0.1035;
                }else if (date_s2 >=new  Date('1997-10-23') && date_s2 <new  Date('1998-03-25')) {
                a0 = 0.0765;
                a1 = 0.0864;
                a2 = 0.0936;
                a3 = 0.0990;
                a4 = 0.1053;
                }else if (date_s2 >=new  Date('1996-08-23') && date_s2 <new  Date('1997-10-23')) {
                a0 = 0.0918;
                a1 = 0.1008;
                a2 = 0.1098;
                a3 = 0.1170;
                a4 = 0.1242;
                }else if (date_s2 >=new  Date('1996-05-01') && date_s2 <new  Date('1996-08-23')) {
                a0 = 0.0972;
                a1 = 0.1098;
                a2 = 0.1314;
                a3 = 0.1494;
                a4 = 0.1512;
                }else if (date_s2 >=new  Date('1995-07-01') && date_s2 <new  Date('1996-05-01')) {
                a0 = 0.1008;
                a1 = 0.1206;
                a2 = 0.1350;
                a3 = 0.1512;
                a4 = 0.1530;
                }else if (date_s2 >=new  Date('1995-01-01') && date_s2 <new  Date('1995-07-01')) {
                a0 = 0.0900;
                a1 = 0.1098;
                a2 = 0.1296;
                a3 = 0.1458;
                a4 = 0.1476;
                }else if (date_s2 >=new  Date('1993-07-11') && date_s2 <new  Date('1995-01-01')) {
                a0 = 0.0900;
                a1 = 0.1098;
                a2 = 0.1224;
                a3 = 0.1386;
                a4 = 0.1404;
                }else if (date_s2 >=new  Date('1993-05-15') && date_s2 <new  Date('1993-07-11')) {
                a0 = 0.0882;
                a1 = 0.0936;
                a2 = 0.1080;
                a3 = 0.1206;
                a4 = 0.1224;
                }else  {  //if (date_s2 >=new  Date('1991-04-21') && date_s2 <new  Date('1993-05-15'))
                a0 = 0.0810;
                a1 = 0.0864;
                a2 = 0.0900;
                a3 = 0.0954;
                a4 = 0.0972;
            }






            this.rate1=a0;
            this.rate2=a1;
            this.rate3=a2;
            this.rate4=a3;
            this.rate5=a4;

            console.log('this.level before:',this.level)
       
  



            if(gap<=180){
                this.level='六个月以内';
                this.day1=gap;
                this.day2=0;
                this.day3=0;
                this.day4=0;
                this.day5=0;

            }
            else if (gap > 180 && gap<360 ){
                this.level="六个月至一年";
                this.day1=180;
                this.day2=gap-180;
                this.day3=0;
                this.day4=0;
                this.day5=0;

            }
            else if (gap > 360 && gap < 1080) {
                this.level="一年至三年";
                this.day1=180;
                this.day2=180;
                this.day3=gap-360;
                this.day4=0;
                this.day5=0;
 
            }
            else if (gap> 1080 && gap < 1800) {
                this.level="三年至五年";
                this.day1=180;
                this.day2=180;
                this.day3=720;
                this.day4=gap-1080;
                this.day5=0;

         
            }
            else if (gap> 1800) {
                this.level="五年以上";
                this.day1=180;
                this.day2=180;
                this.day3=720;
                this.day4=720;
                this.day5=gap-1800;
     
            }

            var reslut_pre 

             
            if(this.mode=='1'){  //分段

                if (gap <= 180) {
                    interest = t * (a0 / this.day_base) * gap ;   
                    this.amount1=filters.toFix(interest);
                    this.amount2=0
                    this.amount3=0
                    this.amount4=0
                    this.amount5=0
            
                }
                else if (gap > 180 && gap <= 360) {       
                    interest = (gap - 180) * (a1/this.day_base) *t + 180 * (a0/this.day_base)*t;
                    this.amount1= filters.toFix(180 * (a0 / this.day_base) * t);
                    this.amount2=filters.toFix((gap - 180) * (a1 / this.day_base) * t);
                    this.amount3=0
                    this.amount4=0
                    this.amount5=0
                
                }
                else if (gap > 360 && gap <= 1080) {       
                    interest = (gap - 360) * (a2/this.day_base)*t + 180 * (a1/this.day_base)*t + 180 * (a0/this.day_base)*t;
                    this.amount1=filters.toFix(180 * (a0 / this.day_base) * t);
                    this.amount2= filters.toFix(180 * (a1 / this.day_base) * t);
                    this.amount3=filters.toFix((gap - 360) * (a2 / this.day_base) * t) ;
                    this.amount4=0
                    this.amount5=0
            
                }
                else if (gap > 1080 && gap <= 1800) {      
                    interest = (gap - 1080) * (a3/this.day_base)*t + 720 * (a2/this.day_base)*t + 180 * (a1/this.day_base)*t + 180 * (a0/this.day_base)*t;  
                    this.amount1=filters.toFix(180 * (a0 / this.day_base) * t);
                    this.amount2= filters.toFix(180 * (a1 / this.day_base) * t);
                    this.amount3=filters.toFix(720 * (a2 / this.day_base) * t);
                    this.amount4=filters.toFix((gap - 1080) * (a3 / this.day_base) * t);
                    this.amount5=0
            
                
                }
                else if (gap > 1800) {         
                    interest = (gap - 1800) * (a4/this.day_base)*t + 720 * (a3/this.day_base)*t + 720 * (a2/this.day_base)*t + 180 * (a1/this.day_base)*t + 180 * (a0/this.day_base)*t;
                
                    this.amount1=filters.toFix(180 * (a0 / this.day_base) * t );
                    this.amount2= filters.toFix(180 * (a1 / this.day_base) * t);
                    this.amount3=filters.toFix(720 * (a2 / this.day_base) * t);
                    this.amount4=filters.toFix(720 * (a3 / this.day_base) * t);
                    this.amount5=filters.toFix((gap - 1800) * (a4 / this.day_base) * t) ;

            
                }
                reslut_pre = parseFloat(this.amount1) + parseFloat(this.amount2) + parseFloat(this.amount3) + parseFloat(this.amount4) + parseFloat(this.amount5);


                this.algorithm=''



            }else{  //不分段

                if(this.level=='六个月以内'){
                    reslut_pre=  gap * (a0 / this.day_base) * t
                    this.current_int=a0

                    this.algorithm=gap+' * '+' ('+a0+'/'+this.day_base+')'+' * '+ t
                  
                }else if(this.level=='六个月至一年'){
                    reslut_pre=  gap * (a1 / this.day_base) * t
                    this.current_int=a1
                    this.algorithm=gap+' * '+' ('+a1+'/'+this.day_base+')'+' * '+ t
                
                }else if(this.level=='一年至三年'){
                    reslut_pre=  gap * (a2 / this.day_base) * t
                    this.current_int=a2
                    this.algorithm=gap+' * '+' ('+a2+'/'+this.day_base+')'+' * '+ t
                  
                }else if(this.level=='三年至五年'){
                    reslut_pre=  gap * (a3 / this.day_base) * t
                    this.current_int=a3
                    this.algorithm=gap+' * '+' ('+a3+'/'+this.day_base+')'+' * '+ t
                }else if(this.level=='五年以上'){
                    reslut_pre= gap * (a4 / this.day_base) * t
                    this.current_int=a4
                    this.algorithm=gap+' * '+' ('+a4+'/'+this.day_base+')'+' * '+ t
                }
      
                interest=reslut_pre
        


            }

            

            



            console.log('this.ishalf:',this.ishalf)

            if (this.ishalf == '1'){   
         
                this.lixi=filters.toFix(reslut_pre);
                this.result1=filters.toFix(reslut_pre);
                this.result2=filters.toFix(parseFloat(t) + parseFloat(interest));
                this.day_sum=this.day1 + this.day2 + this.day3 + this.day4 + this.day5;

            }
            else if (this.ishalf == '2') {   
         

                this.lixi=reslut_pre;
                this.result1= reslut_pre*2;
                this.result2=filters.toFix(parseFloat(t) + parseFloat(interest))*2;
                this.day_sum=this.day1 + this.day2 + this.day3 + this.day4 + this.day5;



            }

            // console.log('interest:',interest)
            // console.log('this.result2:',this.result2)

        
          if(this.mode=='1'){

                let total={  // current_int 不分段模式下的利率
                    current_int: this.current_int ,amount1:this.amount1,amount2:this.amount2,amount3:this.amount3,
                    amount4:this.amount4 ,amount5:this.amount5,
                    day1:this.day1,day2:this.day2, day3:this.day3 ,day4:this.day4,day5:this.day5 ,
                    rate1: a0,  rate2:a1, rate3:a2,   rate4:a3,   rate5:a4 ,level:this.level, s3:this.s3 ,
                    day_sum:gap,lixi:reslut_pre
            
                }
            
                this.resArr=total

                // console.log("total:",total)


            this.tableData=  [{
                name: '六个月内',
                ratio:this.rate1,
                days:this.day1,
                amount:this.amount1,
                }, {
                name: '六个月至一年',
                ratio:this.rate2,
                days:this.day2,
                amount:this.amount2,
                }, {
                name: '一年至三年',
                ratio:this.rate3,
                days:this.day3,
                amount:this.amount3,
                }, {
                name: '三年至五年',
                ratio:this.rate4,
                days:this.day4,
                amount:this.amount4,
                }, {
                name: '五年以上',
                ratio:this.rate5,
                days:this.day5,
                amount:this.amount5,
                }, {
                name: '合计',
                ratio:'/',
                days:this.day_sum,
                amount:this.lixi,
            }];


          }else{

            this.tableData=  [{
                name: this.level,
                ratio:this.current_int,
                days:this.day_sum,
                amount:this.lixi,
                },
                
                // {
                // name: '六个月至一年',
                // ratio:this.rate2,
                // days:this.day2,
                // amount:this.amount2,
                // }, {
                // name: '一年至三年',
                // ratio:this.rate3,
                // days:this.day3,
                // amount:this.amount3,
                // }, {
                // name: '三年至五年',
                // ratio:this.rate4,
                // days:this.day4,
                // amount:this.amount4,
                // }, {
                // name: '五年以上',
                // ratio:this.rate5,
                // days:this.day5,
                // amount:this.amount5,
                // }, {
                // name: '合计',
                // ratio:'/',
                // days:this.day_sum,
                // amount:this.lixi,   }
            
            
            ];






          }


           




            // document.getElementById('function_wrap').style.height="1100px";
            // document.getElementById('function_box0').style.height="1000px";    

          


        },



        bind_download(){
      
            var that=this
            if(!this.resArr){
                this.$message.error('需先计算得出有效结果');
            }

            if(this.mode=='2'){
        
                this.$message.error('只有分段模式支持表格导出');
                return
            }

            var data= { 
                whattodo: "download_int_excel1",
                // tableData:  that.result ,// {"total_lpr":this.tableData} ,
                pre_filename:guid2(),
                // algorithm:this.algorithm || []
                tableData:this.resArr,
             
            }
 
            

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let url= this.$root.rootUrl+'mini_app_vip'
            this.axios.post(url,data
            ).then(function (res) {
                var result=res.data
                window.console.log(res)
                if(result.status=='badgate'){
                    that.$message({
                        message: '请先登录哦',
                        type: 'warning'
                    });

                }else if(result.status=='ok'){
                    that.DownLoad(result.link)
                }else if(result.status=='fail'){
                    that.$message.error(result.failMsg);
                }
                loading.close();
            
                
            }).catch(function (error) {
                window.console.log(error);
                loading.close();
            });


        },


        
        DownLoad(url){
         
            window.open(url, '_blank');

   
        },



    }

	}
</script>

<style   >

	
body
{

    background-color: #f0f0f0;
  
} 

/* .el-date-editor--date{ 
    max-width: 200px; 
}  */

 .el-input__inne{
     width: auto;
 }

 .guide{
  /* font-size:22rpx; */
  /* float: right; */
  /* padding-right: 20rpx; */
  /* text-decoration: underline; */
  /* margin-right: 20px; */
  color: rgb(19, 109, 145);
  /* cursor: pointer; */

  /* border: 1px dashed #1557a1; */

  width:100%;
}
</style>
 